<style scoped>
</style>

<template>
<v-overlay style="z-index:999" :value="this.$store.getters['Drawer/GET_LOADER']">
    <v-progress-circular indeterminate size="35"></v-progress-circular>
</v-overlay>
</template>

<script>
export default {
    name: "Loader",
    props: {

    },
    data: () => ({
        // overlay: false,
    }),
    created() {
        
        // console.log(this.$store.getters['Drawer/GET_LOADER'])
    }
    //   methods: {
    //     progress() {
    //       this.overlay = true
    //     },
    //     progress_end() {
    //       this.overlay = false
    //     }
    //   }
};
</script>
